interface ModalMistakeResponse {
    status: 'success';
    data: {
        status: 'error' | 'success';
        message?: string;
    };
}

declare global {
    function sendMistakeFeedback(payload: Record<string, string>): Promise<ModalMistakeResponse>;
}

export class ModalMistake {
    isFeedbackMistakeOpened = false;
    $modal: JQuery<HTMLElement>;
    $form: JQuery<HTMLFormElement>;
    $submitBtn: JQuery<HTMLButtonElement>;
    $selectedText: JQuery<HTMLElement>;
    $selectedTextInput: JQuery<HTMLInputElement>;

    constructor() {
        this.$modal = $('.feedback-mistake-modal');
        this.$selectedText = $('.feedback-mistake-modal__selected-text');
        this.$form = this.$modal.find('form');
        this.$selectedTextInput = this.$form.find<HTMLInputElement>('[name="text"]');
        this.$submitBtn = this.$modal.find<HTMLButtonElement>('[type="submit"]');

        this.bindEvents();
    }

    bindEvents() {
        $(document).on('keydown', event => {
            if (this.isFeedbackMistakeOpened) {
                return;
            }

            if (event.code === 'Enter' && event.ctrlKey) {
                this.tryToOpen();
            }
        });

        this.$modal.on('hide.bs.modal', event => {
            this.isFeedbackMistakeOpened = false;
            this.$selectedTextInput.val('');
        });

        this.$form.on('submit', this.handleFormSubmit.bind(this));
    }

    handleFormSubmit(e: JQuery.Event) {
        e.preventDefault();
        const arVal = this.$form.serializeArray();
        const payload: Record<string, string> = {};

        arVal.forEach(({name, value}) => payload[name] = value);

        if (typeof sendMistakeFeedback === 'function') {
            this.$submitBtn.prop('disabled', true);
            sendMistakeFeedback(payload).then(res => {
                alert(res.data.message);

                if (res.data.status === 'success') {
                    // @ts-ignore
                    this.$modal.modal('hide');
                }
            })
                .catch(error => alert('Ошибка'))
                .finally(() => this.$submitBtn.prop('disabled', false));
        }
    }

    tryToOpen() {
        console.log(this);
        const selectedText = this.getSelectionText();

        if (!selectedText) {
            return;
        }

        this.isFeedbackMistakeOpened = true;
        this.$selectedText.text(selectedText);
        this.$selectedTextInput.val(selectedText);
        console.log(this.$selectedTextInput, selectedText);
        // @ts-ignore
        this.$modal.modal('show');
    }

    getSelectionText() {
        let text = '';
        if (window.getSelection) {
            text = window.getSelection().toString();
            // @ts-ignore
        } else if (document.selection && document.selection.type !== 'Control') {
            // @ts-ignore
            text = document.selection.createRange().text;
        }
        return text;
    }
}
